import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { has } from "ramda";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import ClearIcon from "@material-ui/icons/Clear";
import LinearProgress from "@material-ui/core/LinearProgress";

const useStyles = makeStyles((theme) => ({
  clearIcon: {
    cursor: "pointer",
  },
  fileName: {
    flex: 1,
    fontSize: 16,
    color: theme.palette.primary.main,
  },

  fileNameRow: {
    display: "flex",
    alignItems: "center",
    marginTop: 20,
  },

  border: {
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
    borderBottomColor: theme.palette.primary.main,
  },

  error: {
    color: "red",
  },
}));

const FileRow = ({ file, fileRemoved }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column">
      <div
        className={clsx(classes.fileNameRow, {
          [classes.border]: !has("progress", file),
          [classes.error]: has("status", file) && file.status === "failed",
        })}
      >
        <span className={classes.fileName}>{file.name}</span>
        <ClearIcon
          className={classes.clearIcon}
          onClick={() => fileRemoved(file)}
        />
      </div>
      {has("progress", file) && (
        <LinearProgress variant="determinate" value={file.progress} />
      )}
      {has("status", file) && file.status === "failed" && (
        <div className={classes.error}>
          Unable to upload this file, please remove and try again.
        </div>
      )}
    </Grid>
  );
};

export default FileRow;
